<script>
import NavBar from '@components/nav-bar'
import FooterBar from '@components/nav-footer'
import _ from 'lodash'

export default {
  components: { NavBar, FooterBar },
  computed: {
    headerPanel() {
      return _.get(this, '$store.state.referrer.referrerData.headerPanel')
    },
  },
  mounted() {
    if (
      (this.$route.path.includes('full-vehicle-report') ||
        this.$route.path.includes('order-confirmation')) &&
      !this.headerPanel.logo.includes('../')
    ) {
      this.headerPanel.logo = '../' + this.headerPanel.logo
    }
  },
  page: {
    meta: [
      {
        name: 'siteID',
        content: _.get(this, '$store.state.referrer.referrerData.siteID', '0'),
      },
      {
        name: 'robots',
        content: 'index,follow',
      },
    ],
  },
  created() {
    if (
      '-ms-scroll-limit' in document.documentElement.style &&
      '-ms-ime-align' in document.documentElement.style
    ) {
      // detect it's IE11
      window.addEventListener(
        'hashchange',
        (event) => {
          var currentPath = window.location.hash.slice(0)
          if (this.$route.path !== currentPath) {
            this.$router.push(this.$route.path)
          }
        },
        false
      )
    }
  },
}
</script>

<template>
  <div :class="$style.container">
    <NavBar />
    <div v-if="headerPanel" class="partnerPanel navMarginMobile mainLayout">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="row row d-flex align-items-center">
              <div class="partnerName col-md-4 col-7">
                <h3>
                  Welcome to AutoCheck
                  <sup>®</sup>
                </h3>
                <span>{{ headerPanel.title }}</span>
              </div>
              <div class="partnerLogo col">
                <img :src="headerPanel.logo" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot />
    <FooterBar />
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
